import popupHeaderComponent from './popupHeader.component';

const popupHeaderModule = angular.module('app.common.ertPopupHeader', [])
	.component('ertPopupHeader', popupHeaderComponent)
	.name;

export default popupHeaderModule;
